module.exports = {"510812100":"朝天镇","510812101":"大滩镇","510812102":"羊木镇","510812103":"曾家镇","510812104":"中子镇","510812105":"沙河镇","510812200":"陈家乡","510812201":"小安乡","510812202":"鱼洞乡","510812203":"东溪河乡","510812204":"花石乡","510812205":"蒲家乡","510812206":"西北乡","510812207":"宣河乡","510812208":"转斗乡","510812209":"青林乡","510812210":"平溪乡","510812211":"两河口乡","510812212":"李家乡","510812213":"汪家乡","510812214":"麻柳乡","510812215":"临溪乡","510812216":"文安乡","510812217":"马家坝乡","510812218":"柏杨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510812.json
// module id = 2131
// module chunks = 0